import React from "react";
import PropTypes from "prop-types";

const Button = ({
  children,
  isLoading = false,
  variant = "primary",
  className = "",
  disabled = false,
  type = "button",
  ...rest
}) => {
  const classes = [
    "rfBtn",
    variant === "outline" ? "rfBtnOutline" : "",
    isLoading ? "isLoading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || isLoading}
      aria-busy={isLoading || undefined}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  variant: PropTypes.oneOf(["primary", "outline"]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default Button;
